<template>
  <PageContentLayoutOnly headerColor="#fafafa">
    <div>
      <div class="pb-3">
        <button
          @click.prevent="finalizeMessageFromState(true)"
          :disabled="!smsMessage && !smsSubject"
          class="button is-primary is-rounded"
        >
          Save
        </button>
      </div>
      <div scheduling class="notification headerColor" v-if="formData">
        <div>
          <MessageComposer
            message="*Please note:* Max characters for SMS are 100 characters."
            :finalizeMessage="finalizeMessage"
            :saveMessageForFinalize="saveMessageForFinalize"
            :showSendTestEmail="false"
            :showPreview="true"
            :showAttachments="false"
            :processPreview="processFinalPreview"
            :showSms="true"
            :composedText="smsMessage"
            :composedSubject="smsSubject"
            :isReadOnly="hasReadonly"
            :isOnChanged="true"
          />
        </div>
        <div class="box is-12" v-if="hasReadonly === undefined || hasReadonly !== true">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <transition name="fade" mode="out-in" appear>
              <form @submit.prevent="handleSubmit(onFormSubmit)" class="form">
                <fieldset>
                  <div class="columns pt-5">
                    <div>
                      <div class="force-center subtitle pb-5">
                        <span style="padding-left: 365px;">Preview</span>
                      </div>
                      <div class="columns">
                        <div class="column is-6">&nbsp;</div>
                        <div class="column is-6">
                          <img :src="require('@/assets/images/transparent_cell.png')" />
                          <div class="font-centered">
                            <div
                              class="font-bold"
                              v-if="typeof (composedSubject === 'string')"
                              v-html="composedSubject"
                            ></div>
                            <div
                              v-if="typeof (composedText === 'string')"
                              v-html="composedText"
                            ></div>
                          </div>
                        </div>
                        <div class="column is-4">&nbsp;</div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                    <div class="field">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </fieldset>
              </form>
            </transition>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import { data } from './keys/data'
import { methods } from './keys/methods'
import MessageComposer from '@/pages/Shared/mailingCommunications/components/communicationModal/keys/MessageComposer'

export default {
  name: 'ComposeSmsCommunication',
  components: {
    ValidationObserver,
    ValidationProvider,
    PageContentLayoutOnly,
    MessageComposer
  },

  data,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      ...mapGetters('communication', [
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingTypeID',
        'mailingType',
        'smsMessage',
        'smsSubject',
        'mailingCommunicationID',
        'communicationDescription',
        'selectedDeliveryOwnerIDs',
        'selectedDeliveryOwners',
        'deliveryDate',
        'isColor',
        'isFullDuplex',
        'hasReadonly'
      ])
    })
  },

  mounted() {
    this.reload()
  },

  watch: {
    hoaId() {
      this.reload()
    }
  },

  methods,

  i18n: {
    messages: {
      en: {
        composeSmsMessage: { title: 'Save SMS Communication' }
      }
    }
  }
}
</script>

<style lang="scss">
#update-work-order .my-grid-class {
  height: 400px;
}

#update-work-order tbody {
  min-height: 100px !important;
  overflow: auto !important;
}
</style>
